import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LiveContext } from 'src/context/LiveContext';
import styles from './LiveHeader.module.scss';

export function LiveJoinUrl() {
  const { joinCode, shortUrl } = useContext(LiveContext);
  const { t } = useTranslation();

  return (
    <div className={styles.liveJoinUrl}>
      <span>
        {t('liveAdmin.joinAt')} <strong>{shortUrl}</strong>
      </span>
      <span style={{ color: '#D8D8D8' }}> | </span>
      <span>
        {t('liveAdmin.useCode')} <strong>{joinCode}</strong>
      </span>
    </div>
  );
}
